import { searchVehicles } from 'apis/vehicleApis'
import { SRP_INIT_QUERY, VIN_CHARACTERS_REGEX } from 'common/constants'
import { isAnyChildrenFilterExistValue, resetChildrenFilters, selectChildrenFilter } from 'common/helpers'
import { MultiLanguageCode } from 'common/languageCodes'
import { OverlayLoader } from 'components/Loader'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { useDashboardStore } from 'store/useDashboardStore'
import { ISearchFilterResult } from 'types/vehicleTypes'
import { getVdpUrl } from 'utils/urlUtils'
import * as Yup from 'yup'
import shallow from 'zustand/shallow'

interface IProps {
  loading: boolean
}

export const SearchVin = ({ loading: ContentLoading }: IProps) => {
  const [searching, setSearching] = useState(false)
  const [showMessage, setShowMesage] = useState(false)
  const { filters: ContentData } = useDashboardStore((state) => state, shallow)
  const [searchFilters, setSearchFilters] = useState<ISearchFilterResult[]>([])

  useEffect(() => {
    if (!ContentLoading) {
      setSearchFilters([...ContentData] as ISearchFilterResult[])
    }
  }, [ContentLoading])

  const SubmitSearch = async (values) => {
    resetChildrenFilters(searchFilters)
    selectChildrenFilter(searchFilters, 'VIN', values.vin)
    try {
      setSearching(true)
      const response = await searchVehicles({
        ...SRP_INIT_QUERY,
        SearchQuery: { ...SRP_INIT_QUERY.SearchQuery, SearchFilters: searchFilters }
      })
      if (response) {
        if (!isAnyChildrenFilterExistValue(searchFilters, 'VIN', 'VIN', values.vin)) {
          setShowMesage(true)
        } else {
          window.location.href = getVdpUrl(response.Items?.[0]?.vehicle?.InstanceID)
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setSearching(false)
    }
  }

  const schema = Yup.object({
    vin: Yup.string().length(17, 'Must be 17 characters')
  })

  return (
    <>
      <Formik
        initialValues={{ vin: '' }}
        onSubmit={SubmitSearch}
        validationSchema={schema}
        onReset={() => {
          setShowMesage(false)
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            <Row>
              <Form.Group as={Col} xs={12} lg={8} sm={8} controlId="vin">
                <Row>
                  <Form.Label className="section-name" column sm="auto">
                    <h5>Search VIN</h5>
                  </Form.Label>
                  <Col className="p-0">
                    <Form.Control
                      type="input"
                      placeholder="#17 digit VIN"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.vin}
                      isInvalid={!!props.errors.vin}
                      onKeyDown={(e) => {
                        if (!VIN_CHARACTERS_REGEX.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      maxLength={17}
                    />
                    <Form.Control.Feedback tooltip={false} type="invalid">
                      {props.errors.vin}
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} className="pl-0">
                <Row noGutters className="mx-lg-0">
                  <Button type="submit" disabled={!(props.isValid && props.dirty)} variant="primary" className="mx-2">
                    SEARCH
                  </Button>
                  <Button type="reset" className="btn-secondary px-2">
                    CLEAR ALL
                  </Button>
                </Row>
              </Form.Group>
            </Row>
          </Form>
        )}
      </Formik>
      {searching && <OverlayLoader />}
      {showMessage && (
        <Alert className="col-6 col-lg-8 col-sm-8" variant="danger" onClose={() => setShowMesage(false)} dismissible>
          <FormattedMessage id={MultiLanguageCode.INV_VEH_NOTFOUND} />
        </Alert>
      )}
    </>
  )
}
